'use strict';

import "angular-messages";
import "angular-ui-bootstrap";

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.requires.push('ui.bootstrap');
EwSiteApp.requires.push('ngMessages');

EwSiteApp.controller('jobadsSubmitCtrl', ['$scope', function($scope){
	
	$scope.form;
	$scope.submitted = false;
	
	$scope.formSubmit = function(e, type){
		e.preventDefault();
		$scope.submitted = true;
		let is_grecaptcha = $scope.form.find('#g-recaptcha-response-hidden').length > 0;
		if (is_grecaptcha && typeof (grecaptcha) !== 'undefined') {
			grecaptcha.ready(function () {
				grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action: 'submit'}).then(function (token) {
					if (document.getElementById('g-recaptcha-response-hidden')) {
						$('#g-recaptcha-response-hidden').val(token);
					} else {
						var inp = document.createElement('input');
						inp.type = 'hidden';
						inp.name = 'g-recaptcha-response';
						inp.value = token;
						$scope.form[0].appendChild(inp);
					}
//					$scope.form[0].submit();

					if (
							type=='cv' && 
							typeof ($scope.name) !== 'undefined' && 
							typeof ($scope.phone) !== 'undefined' && 
							typeof ($scope.email) !== 'undefined' && 
							(angular.element('#cv_file').hasClass('file-added')) && 
							typeof ($scope.form_accept) !== 'undefined'
					) {
						$scope.submitted = true;
						$scope.form[0].submit();
					}
					else if(
							type=='list' && 
							typeof ($scope.name) !== 'undefined' && 
							typeof ($scope.email) !== 'undefined' && 
							(angular.element('#cv_file').hasClass('file-added'))
					){
						$scope.submitted = true;
						$scope.form[0].submit();
					}
					else {
						$scope.submitted = false;
					}
				});
			});
		} else {
			$scope.form[0].submit();
		}
	};
	
}]).directive('jobadsSubmit', function(){
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});

EwSiteApp.controller('jobadsApplyCtrl', ["$scope", "$sce", "$filter", "$http", "$log", function ($scope, $sce, $filter, $http, $log) {
	$scope.sumbitUrl = jobadsApplyData.submitUrl;
	$scope.photoid = [];
	$scope.sitekey = jobadsApplyData.recaptcha.siteKey;
	$scope.submited = false;
	$scope.loading = false;
	$scope.message = '';
	$scope.errors = [];
	$scope.rules_accept = false;
	$scope.data = {
		name: '',
		phone: '',
		email: '',
		message: '',
		photoid: []
	};
	$scope.recaptchaResponse = null;
	
	$scope.send = function () {
		if ($scope.isValid() && typeof grecaptcha !== 'undefined') {
			grecaptcha.ready(function () {
				if ($scope.sitekey) {
					$scope.loading = true;
					grecaptcha.execute($scope.sitekey, {action: 'submit'}).then(function (token) {
						$scope.recaptchaResponse = token;
						$scope.submitForm();
					});
				} else {
					$scope.submited = true;
					console.log("no recaptcha siteKey");
				}
			});
		} else {
			$scope.loading = false;
			console.log("no recaptcha service");
		}
	};
	
	$scope.explicitlyTrustedHtml = function (text) {
		return $sce.trustAsHtml(text);
	};
	
	$scope.submitForm = function () {
		if ($scope.sumbitUrl !== '') {

			let post_data = $scope.data;

			if (typeof jobadsApplyData.recaptcha !== 'undefined') {
				post_data[jobadsApplyData.recaptcha.field] = $scope.recaptchaResponse;
			}
			$http({
				method: 'POST',
				url: $scope.sumbitUrl,
				data: post_data,
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (response.data.success) {
					$scope.message = $scope.explicitlyTrustedHtml(response.data.message);
					$scope.submited = true;
				} else if (angular.isDefined(response.data.messages)) {
					$scope.errors = response.data.messages;
				}
				if (angular.isDefined(response.data.debug)) {
					$log.debug(response.data.debug);
				}
			}).then(function () {
//				$scope.submited = true;
				$scope.loading = false;
			});
		}
	};
	
	$scope.isValid = function () {
		if ($scope.rules_accept === false) {
			return false;
		}
		return true;
	};

	$scope.hasErrors = function () {
		return $scope.errors.length > 0;
	};
	
}]);
